/*
电站运行看板--故障--故障趋势曲线图
 */
import React, { Component } from "react";
import Echarts from "echarts";
import ScGridTable from "@/components/display/table/gridTableCore";
import { Spin, Tooltip, Button, Select } from "antd";
import ExportJsonExcel from 'js-export-excel';
import { QuestionCircleFilled } from "@ant-design/icons";

class ErrorGroup extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      areaList:[

      ],
      dataSource:[],
      opTypeV:null,
      quanguoCityArry:[],
      btnType: 1, // 按钮状态。 1图2表
      tableConfig: null,
    };
  }

  handleClick = () => {
    var dataSource = this.state.dataSource;
    var list;
    if (this.state.opTypeV != null && this.state.opTypeV != '全部')
    {
      list = [];
      dataSource.forEach((z) => {
        if (this.state.opTypeV == z.levenName)
        {
          list.push(z)
        }
      });
    } else {
      list = dataSource;
    }
    var option={};
    let dataTable = [];
    if (list) {
      for (let i in list) {
        let obj = {}
        obj['日期'] = list[i]['cityName'];
        obj['故障原因'] = list[i]['levenName'];
        obj['故障次数'] = list[i]['faultCount'];
        dataTable.push(obj);
      }
    }
    var header = ['日期', '故障原因', '故障次数'];
    option.fileName = '故障曲线数据导出'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  };

  /**
   * 初始化页面方法
   */
  componentDidMount() {
    this.initSelectOptions(this.props.dataSource, this.state.opTypeV);
    // 默认加载
    this.stubIntactChart(this.props.dataSource, this.state.opTypeV);
  }

  componentWillMount() {
    this.initSelectOptions(this.props.dataSource);
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig(this.props.dataSource);
  }

  /**
   * 父组件参数修改后，子组件调用方法
   */
  componentWillReceiveProps(nextProps) {
    // 如果数据源改变，则重新渲染图表
    if (JSON.stringify(nextProps.dataSource) !== JSON.stringify(this.props.dataSource)) {
      this.initSelectOptions(nextProps.dataSource);
      if (this.state.btnType === 1) {
        this.stubIntactChart(nextProps.dataSource, this.state.opTypeV);
      } else {
        this.initTableConfig(nextProps.dataSource, this.state.opTypeV);
      }
    }
  }

  initSelectOptions(dataSource) {
    var list = ['全部'];
    if (dataSource && dataSource.length > 0) {
      dataSource.forEach((v) => {
        if (list.indexOf(v.levenName) == -1)
        {
          list.push(v.levenName);
        }
      });
      this.setState({
        areaList:list
      })
    }
  }

  /** */
  initTableConfig = (dataSource, opTypeV) => {
    var list;
    this.setState({
      dataSource:dataSource
    })
    if (opTypeV != null)
    {
      list = [];
      dataSource.forEach((z) => {
        if (opTypeV == z.levenName)
        {
          list.push(z)
        }
      });
    } else {
      list = dataSource;
    }
    this.setState({
      tableConfig: {
        tableKey: "errorGroupTable",
        tableColumns: [
          {
            name: "日期",
            key: "cityName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "故障原因",
            key: "levenName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "故障次数",
            key: "faultCount",
            colType: "textCol",
            align: "center",
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: list,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart(dataSource, opTypeV) {
    const dataArry = dataSource; // 接口获取数据
    this.setState({
      dataSource:dataSource
    })
    let maxVal = 0;
    var list = [];
    const failList = [];
    const xAxisData = [];
    var total = 0;
    console.info('诉苦：')
    console.info(dataArry)
    dataArry.forEach((v) => {
      if (opTypeV != null)
      {

        if (v.levenName != opTypeV)
        {
          return;
        }
      }
      if (xAxisData.indexOf(v.cityName) == -1)
      {
        xAxisData.push(v.cityName)
        failList.push({
          value: v.faultCount || 0,
          info: {
            faultCount: v.faultCount,
            cityName:v.cityName
          },
        });
        total += v.faultCount;
        if (maxVal < v.faultCount)
        {
          maxVal = v.faultCount;
        }
      } else {
        failList.forEach((z) => {
          if (v.cityName == z.info.cityName)
          {
            total += v.faultCount;
            z.value += v.faultCount;
            z.info.faultCount += v.faultCount;
            if (maxVal < z.value)
            {
              maxVal = z.value;
            }
          }
        });
      }
    });
    var rate = 0;
    failList.forEach((z, index) => {
      if (index == (failList.length - 1))
      {
        z.info.rate = z.info.faultCount == 0 ? 0 : (100 - parseFloat(rate)).toFixed(2);
      } else {
        z.info.rate = z.info.faultCount == 0 ? 0 : ((z.info.faultCount / total) * 100).toFixed(2);
        rate += parseFloat(z.info.rate);
      }
      
    });


    // 设置X轴
    maxVal = Math.ceil(Number(maxVal) / 10) * 10;
    const myChart = Echarts.init(document.getElementById("charge-success-firmware-chart2"));
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        backgroundColor: "rgba(0,0,0,.5)",
        show: true,
        formatter: (params) => {
          let str = "";
          if (params[0].axisValue) {
            str += `<div  style="padding:10px 24px 3px 10px">${params[0].axisValue}</div>`;
            str += `<div  style="padding:3px 24px 3px 10px">故障数：${params[0].data.info.faultCount},比例：${params[0].data.info.rate}%</div>`;
            return str;
          }
        },
        // position: function (pos, params, dom, rect, size) {
        //   // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
        //   var obj = { top: 60 };
        //   obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
        //   return obj;
        // }
      },
      color: ["red", "blue"],
      legend: {
        selectedMode: false,
        textStyle: {
          padding: [10, 0],
        },
        top: 0,
        itemGap: 15,
        itemWidth: 21,
        itemHeight: 8,
        data: [
          {
            name: "故障数",
          }
        ],
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            // rotate: 35,
            textStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
        },

        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
      ],
      grid: {
        left: "50px",
        right: "50px",
      },
      yAxis: [
        {
          type: "value",
          name: "数量",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: maxVal,
          interval: Math.ceil(maxVal / 10),
          axisLabel: {
            formatter: "{value}",
          },
          nameTextStyle: {
            padding: [0, 25, 10, 0],
            color: "#666",
          },
        },
        {
          type: "value",
          name: "百分比",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: 100,
          interval: 10,
          nameTextStyle: {
            padding: [0, 0, 10, 40],
            color: "#666",
          },
          axisLabel: {
            formatter: "{value}%",
          },
        },
      ],
      series: [
        {
          name: "故障数",
          type: "line",
          yAxisIndex: 0,
          stack: "1",
          data: failList,
          barGap: "-100%",
        },
      ],
      contentToOption: function () {
        // 数据视图刷新的方法
        // this.stubIntactChart();
      },
    };
    myChart.clear();
    myChart.setOption(option);
  }

  btnChange = (type) => {
    this.setState(
      {
        btnType: type,
      },
      () => {
        if (type === 1) {
          this.stubIntactChart(this.props.dataSource, this.state.opTypeV);
        } else {
          this.initTableConfig(this.props.dataSource, this.state.opTypeV);
        }
      },
    );
  };

  render() {
    return (
      <Spin spinning={this.props.loading}>
        <div className='section'>
          <div className='title-box' style={{display:"flex", justifyContent:"space-between"}}>
            <div style={{display:"flex", alignItems:"center"}}>
            <div className='title' style={{marginRight:"5px"}}>故障趋势曲线图<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索范围内各个故障原因发生的次数</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip></div>
            <div style={{marginRight:"5px", width:"120px"}} className='btn-switch-box'>
              <span
                className={this.state.btnType === 1 && "selected-btn"}
                onClick={() => this.btnChange(1)}>
                图
              </span>
              <span
                className={this.state.btnType === 2 && "selected-btn"}
                onClick={() => this.btnChange(2)}>
                表
              </span>
            </div>

            <div style={{    display: 'flex',alignItems: 'center'}}>
                <Button
                onClick={this.handleClick}
                type="primary"
                style={{ margin: "5px" }}>
                导出
              </Button>
              </div>
              </div>

              
              <div className="search-box">
                  <span className="select-label"></span>
                  <Select
                    style={{ width: "120px", marginRight: "8px" }} onSelect={(value, option) => {
                      console.info(value)
                      console.info(option)
                      this.setState({
                        opTypeV: value
                      });
                      
                      if (this.state.btnType === 1) {
                        this.stubIntactChart(this.state.dataSource, (value && value == '全部')  ? null : value);
                      } else {
                        this.initTableConfig(this.state.dataSource, (value && value == '全部')  ? null : value);
                      }
                    }}>
                      {this.state.areaList.map((v) => (
                    <Select.Option value={v}>{v}</Select.Option>
                  ))}
                  </Select>
                  

                </div>
          </div>
          {this.state.btnType === 1 ? (
            <div
              style={{ width: "100%", height: 420, overflowY: "auto" }}
              id='charge-success-firmware-chart2'
            />
          ) : (
            <ScGridTable config={this.state.tableConfig} />
          )}
        </div>
      </Spin>
    );
  }
}

export default ErrorGroup;



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/errorGroup.js